import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useFetch } from "utils/hooks";

import { useQuery } from "@tanstack/react-query";

import { Urls } from "../../urls.ts";

import { BookingResponse } from "./type.ts";

export const useBookingById = () => {
  const { id } = useParams();

  const fetch = useFetch();

  const { data, isFetching, isError } = useQuery<BookingResponse | null, Error, BookingResponse>({
    queryKey: ["booking-id", id],
    enabled: !!id,
    queryFn: () =>
      fetch<BookingResponse>(`${Urls.BookingById}`, {
        method: "GET",
        slug: {
          bookingId: id,
        },
      }),
    gcTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isError) {
      toast.error("Error getting booking");
    }
  }, [isError]);

  return {
    data,
    isFetching,
  };
};
